import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { PurchaseStatisticsQueryService } from './services/purchase-statistics-query.service';
import { PurchaseStatisticsRepository } from './repositories/purchase-statistics.repository';

export const purchaseStatisticsRoutes: Routes = [
  {
    path: 'purchase-statistics',
    loadComponent: () => import('./pages/purchase-statistics.page').then(o => o.PurchaseStatisticsPage),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page').then(o => o.DashboardPage),
      },
      {
        path: 'table',
        loadComponent: () => import('./pages/table/table.page').then(o => o.TablePage),
      },
      {
        path: '**',
        redirectTo: '/purchase-statistics/dashboard',
      },
    ],
    providers: [
      PurchaseStatisticsQueryService, PurchaseStatisticsRepository
    ],
    canActivate: [AuthenticationGuard],
    // data: { permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK }
  },
];
